<template>
	<div class="fill-height">
		<modal-assinatura-eletronica
			v-if="exibirModalAssinaturaEletronica"
			titulo="Assinar"
			nome-botao-confirmar="Assinar"
			:exibir="exibirModalAssinaturaEletronica"
			@fechar-modal="fecharModalAssinaturaTermo"
			@assinar-eletronicamente="assinarEletronicamente"
		></modal-assinatura-eletronica>
		<az-pdf-document-viewer
			v-if="passoEdicaoFinalizado"
			id="azPdfDocumentViewer"
			:src="documentoSrc"
			progress-bar
			default-scale-type="auto"
		></az-pdf-document-viewer>
		<botao-assinar-documento
			v-if="!passoAssinaturaFinalizado"
			id="botaoAssinar"
			@assinar="abrirModalAssinaturaTermo"
		></botao-assinar-documento>
	</div>
</template>

<script>
import { actionTypes } from '@/core/constants'
import ModalAssinaturaEletronica from '@/views/components/assinatura/eletronica/ModalAssinaturaEletronica'
import BotaoAssinarDocumento from '@/views/components/BotaoAssinarDocumento'

export default {
	name: 'termo-desentranhamento-assinar-generico',
	components: { BotaoAssinarDocumento, ModalAssinaturaEletronica },
	props: {
		passoEdicaoFinalizado: {
			type: Boolean,
		},
		passoAssinaturaFinalizado: {
			type: Boolean,
		},
		tipoDocumento: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			idProcessoAquisicao: null,
			exibirModalAssinaturaEletronica: false,
			idTermo: null,
			documentoSrc: null,
			documento: [],
		}
	},
	async mounted() {
		this.setIdTermo()
		this.setIdProcessoAquisicao()
		this.setDocumentoSrc()
		await this.setDocumento()
	},
	methods: {
		abrirModalAssinaturaTermo() {
			this.exibirModalAssinaturaEletronica = true
		},
		fecharModalAssinaturaTermo() {
			this.exibirModalAssinaturaEletronica = false
		},
		async setDocumento() {
			const data = await this.$store.dispatch(
				actionTypes.DOCUMENTOS.EDITOR_TEXTO.BUSCAR_POR_ID,
				this.criarPayload(),
			)
			this.documento = [
				{
					titulo: data.titulo,
					idAssociacao: this.idTermo,
				},
			]
		},
		setDocumentoSrc() {
			this.documentoSrc = `/ata-registro-preco/api/${this.tipoDocumento.path}/documentos/${this.idTermo}/processo-digital/download-impressao`
		},
		setIdTermo() {
			this.idTermo = this.$route.params.idTermo
		},
		setIdProcessoAquisicao() {
			this.idProcessoAquisicao = this.$route.params.id
		},
		async assinarEletronicamente() {
			await this.$store.dispatch(
				actionTypes.DOCUMENTOS.PROCESSO_DIGITAL.ASSINAR_ELETRONICAMENTE,
				this.criarPayload(),
			)
			await this.tratarEventoAssinarTermo()
		},
		async tratarEventoAssinarTermo() {
			this.$emit('assinar-termo')
			this.fecharModalAssinaturaTermo()
		},
		criarPayload() {
			return {
				documento: this.idTermo,
				tipo: this.tipoDocumento,
			}
		},
	},
}
</script>
